import React from 'react';
import Label from './Label';
import LoadingPlaceholder from '../../../muiComponents/LoadingPlaceholder';

interface LabelAndContentBlockProps {
    label: string;
    content: string | React.ReactNode;
    loading?: boolean;
}
const LabelAndContentBlock = (props: LabelAndContentBlockProps) => {
    const { label, content, loading } = props;
    return (
        <>
            {loading ? (
                <>
                    <LoadingPlaceholder variant='text' height={20} />
                    <LoadingPlaceholder variant='text' height={20} />
                </>
            ) : (
                <>
                    <Label text={label} />
                    {typeof content === 'string' ? (
                        <p className='text-preline'>{content || '----'}</p>
                    ) : (
                        content
                    )}
                </>
            )}
        </>
    );
};

export default LabelAndContentBlock;
